// extracted by mini-css-extract-plugin
export var headerCell = "_4m-1";
export var loadingSpinnerContainer = "_4m-4";
export var loadingStateCell = "_4m-5";
export var rowWrapper = "_4m-3";
export var standaloneTable = "_4m-6";
export var table = "_4m-0";
export var white = "_4m-2";